import { Badge, Dropdown } from 'antd';
import ActionsDropDown from 'components/dropdown/layout_actions';
import MenuDropdown from 'components/dropdown/layout_menu';
import NotiDropdown from 'components/dropdown/layout_noti';
import ProfileDropDown from 'components/dropdown/layout_profile';
import TaskDropdown from 'components/dropdown/layout_task';
import dayjs from 'dayjs';
import { EventSourcePolyfill } from 'event-source-polyfill';
import useAuth from 'hooks/useAuth';
import useMember from 'hooks/useMember';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useInfiniteQuery, useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { GET, PUT, layoutMyActions } from 'utils';
import { api } from 'utils/apiRoutes';
import { diffTime, timeBetween } from 'utils/common_function';

const localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);

const Header = () => {
  const { getUserPrefence, getCustomizeDesign } = useMember();

  const [cookies] = useCookies(['access_token', 'refresh_token']);
  const { user } = useAuth();
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);
  const [isOpenActions, setIsOpenActions] = useState<boolean>(false);
  const [isOpenProfile, setIsOpenProfile] = useState<boolean>(false);
  // const [imageUrl, setImageUrl] = useState<RcFile | string>();

  const [state, setState] = useState({
    isOpenNoti: false,
    isOpenTask: false,
  });
  const { isOpenNoti, isOpenTask } = state;
  const avatar = useQuery('get-user-pre', getUserPrefence);
  const logo = useQuery('get-logoWeb-pre', getCustomizeDesign);
  if (logo?.data?.logo) {
    localStorage.setItem('logoUrl', logo?.data?.logo?.url);
  } else {
    localStorage.setItem('logoUrl', '/assets/company.svg');
  }
  const {
    data,
    fetchNextPage,
    refetch: refetchInfinite,
    hasNextPage,
    status,
  } = useInfiniteQuery({
    queryKey: 'get-infinite',
    queryFn: async ({ pageParam = 0 }) => {
      return await GET(`${api.get_noti}/?next_cursor=${pageParam}`);
    },
    getNextPageParam: (page) => {
      return page?.data?.next_cursor;
    },
  });

  const notificationData = data?.pages.reduce((acc, page) => {
    return [...acc, ...page.data?.results];
  }, []);

  const notification = notificationData?.map((item) => {
    const time1 = `${new Date(item.created_at).getHours()}:${new Date(
      item.created_at,
    ).getMinutes()}`;
    const time2 = `${new Date().getHours()}:${new Date().getMinutes()}`;

    return {
      id: item.id,
      message: item?.data.message || item.data.name,
      url: item?.data.url,
      status: item.status,
      created_at: item.created_at,
      time:
        timeBetween(new Date(item.created_at), new Date()) !== 0
          ? timeBetween(new Date(item.created_at), new Date())
          : diffTime(time1, time2),
      action: item.action,
      data: item.data,
      notiType: item.type,
    };
  });
  const notificationsId = notificationData?.map(
    (item: { id: number }) => item.id,
  );
  const {
    data: tasksData,
    fetchNextPage: fetchNextPageTask,
    refetch: refetchInfiniteTask,
    hasNextPage: hasNextPageTask,
  } = useInfiniteQuery({
    queryKey: 'get-infinite-task',
    queryFn: async ({ pageParam = 0 }) => {
      return await GET(`${api.get_main_task}/?next_cursor=${pageParam}`);
    },
    getNextPageParam: (page) => {
      return page?.data?.next_cursor;
    },
  });

  const taskData = tasksData?.pages.reduce((acc, page) => {
    page?.data?.results?.forEach((item) => {
      if (!acc.some((j) => j?.id === item?.id)) {
        acc = [...acc, item];
      }
    });
    return acc;
  }, []);

  const tasks = taskData?.map((item) => {
    const time1 = `${new Date(item?.created_at).getHours()}:${new Date(
      item.created_at,
    ).getMinutes()}`;
    const time2 = `${new Date().getHours()}:${new Date().getMinutes()}`;
    return {
      id: item?.id,
      status: item?.status,
      time:
        timeBetween(new Date(item.created_at), new Date()) !== 0
          ? timeBetween(new Date(item.created_at), new Date())
          : diffTime(time1, time2),
      data: item?.data,
    };
  });

  //count task
  const { data: taskCount, refetch: refetchTaskCount } = useQuery(
    'get-task-count',
    async () => {
      const res = await GET(api.get_task_count);
      return res.data;
    },
    {
      refetchIntervalInBackground: true,
    },
  );
  //count noti
  const { data: notificationCount, refetch: refetchCount } = useQuery(
    'get-noti-count',
    async () => {
      const res = await GET(api.get_noti_count);
      return res.data;
    },
    {
      refetchIntervalInBackground: true,
    },
  );

  const markAsRead = async () => {
    const res = await PUT(`${api.update_noti}/?ids=${notificationsId}`);
    if (res.status === 204) {
      refetchInfinite();
      refetchCount();
    }
  };

  useEffect(() => {
    try {
      const sse = new EventSourcePolyfill(
        process.env.REACT_APP_ENVIRONMENT === 'DEV'
          ? `http://171.244.64.245:8000/api/event/subscribe/`
          : '/api/event/subscribe/',
        {
          headers: {
            Authorization: `Bearer ${cookies.access_token}`,
          },
        },
      );
      sse.onmessage = (e) => {
        const data = JSON.parse(e.data);
        if (data.action !== 'deleted') {
          refetchInfinite({ refetchPage: (_, index) => index === 0 });
          refetchCount();
          refetchInfiniteTask({ refetchPage: (_, index) => index === 0 });
          refetchTaskCount();
        }
      };
      sse.onerror = () => {
        console.error('Error connecting to the event stream');
        // Close the connection if the server is not reachable
        sse.close();
      };
      return () => {
        sse.close();
      };
    } catch (error) {
      console.log(error);
    }
  }, [cookies.access_token]);

  useEffect(() => {
    if (isOpenNoti) {
      refetchCount();
      refetchInfinite();
    }
  }, [isOpenNoti]);

  useEffect(() => {
    if (isOpenTask) {
      refetchTaskCount();
      refetchInfiniteTask();
    }
  }, [isOpenTask]);

  // if (isFetching) return <Loading />;
  return (
    <nav className={'layout_header'}>
      {/*{contextHolder}*/}
      <Dropdown
        trigger={['click']}
        open={isOpenMenu}
        autoFocus={false}
        onOpenChange={() => setIsOpenMenu(!isOpenMenu)}
        dropdownRender={() => <MenuDropdown setIsOpen={setIsOpenMenu} />}
        placement="bottomRight"
      >
        <img
          style={{
            background: isOpenMenu ? '#87b1ef' : '',
            borderRadius: '50%',
            marginLeft: 16,
          }}
          className={'layout_header_menu'}
          src={'/icons/menu.svg'}
          alt={'logo'}
        />
      </Dropdown>
      <Link to={'/'}>
        <img
          className={'layout_header_logo'}
          src={logo?.data?.logo ? logo?.data?.logo?.url : '/assets/company.svg'}
          alt={'logo'}
          width={'100px'}
          height={'42px'}
          style={{
            width: '100px',
            height: '42px',
          }}
        />
      </Link>
      <div style={{ float: 'right', display: 'flex', gap: '10px' }}>
        <Dropdown
          trigger={['click']}
          open={isOpenActions}
          autoFocus={false}
          onOpenChange={() => setIsOpenActions(!isOpenActions)}
          dropdownRender={() => (
            <ActionsDropDown
              setIsOpen={setIsOpenActions}
              items={layoutMyActions}
            />
          )}
          placement="bottomRight"
        >
          <img
            style={{
              background: isOpenActions ? '#87b1ef' : '',
              borderRadius: '10px',
            }}
            className={'layout_header_default_icon'}
            src={'/assets/action.svg'}
            alt={'logo'}
          />
        </Dropdown>

        <Dropdown
          open={isOpenTask}
          onOpenChange={() =>
            setState((p) => ({ ...p, isOpenTask: !isOpenTask }))
          }
          trigger={['click']}
          dropdownRender={() => (
            <TaskDropdown
              refetch={refetchInfiniteTask}
              noti={tasks}
              refetchCount={refetchTaskCount}
              loadMore={() => {
                hasNextPageTask && fetchNextPageTask();
              }}
              isOpen={() => setState((p) => ({ ...p, isOpenTask: false }))}
            />
          )}
          placement="bottomRight"
        >
          <Badge
            count={taskCount?.count}
            overflowCount={10}
            size={'small'}
            style={{ padding: '0px 4px', marginTop: 10 }}
          >
            <img
              style={{
                background: isOpenTask ? '#87b1ef' : '',
                borderRadius: '10px',
              }}
              className={'layout_header_default_icon'}
              src={'/assets/task.svg'}
              alt={'logo'}
            />
          </Badge>
        </Dropdown>

        <Dropdown
          open={isOpenNoti}
          onOpenChange={() =>
            setState((p) => ({ ...p, isOpenNoti: !isOpenNoti }))
          }
          trigger={['click']}
          dropdownRender={() =>
            status === 'loading' ? (
              'loading'
            ) : (
              <NotiDropdown
                refetchCount={refetchCount}
                isOpen={() => {
                  setState((p) => ({ ...p, isOpenNoti: false }));
                }}
                refetch={refetchInfinite}
                noti={notification}
                markAsRead={markAsRead}
                loadMore={() => {
                  hasNextPage && fetchNextPage();
                }}
              />
            )
          }
          placement="bottomRight"
        >
          <Badge
            count={notificationCount?.count}
            overflowCount={10}
            size={'small'}
            style={{ padding: '0px 4px', marginTop: 10 }}
          >
            <img
              style={{
                background: isOpenNoti ? '#87b1ef' : '',
                borderRadius: '10px',
              }}
              src={'/assets/noti.svg'}
              className={'layout_header_default_icon'}
              alt={'logo'}
            />
          </Badge>
        </Dropdown>

        <Dropdown
          trigger={['click']}
          open={isOpenProfile}
          autoFocus={false}
          onOpenChange={() => setIsOpenProfile(!isOpenProfile)}
          dropdownRender={() => (
            <ProfileDropDown setIsOpen={setIsOpenProfile} />
          )}
          placement="bottomRight"
        >
          <span
            className={'layout_header_default_profile'}
            style={{
              background: isOpenProfile ? '#87b1ef' : '',
              borderRadius: '30px',
              padding: '8px 8px',
            }}
          >
            <img
              style={{
                width: 45,
                height: 45,
                borderRadius: '50%',
              }}
              src={
                avatar?.data?.avatar
                  ? avatar?.data?.avatar?.url
                  : user?.title === 'male'
                  ? '/assets/Businessman.png'
                  : '/assets/Businesswoman.png'
              }
              alt={'arr'}
            />
            <img
              style={{
                width: 25,
                height: 25,
                marginLeft: 4,
              }}
              src={'/icons/icon_drop_down.png'}
              alt={'drop_down'}
            />
          </span>
        </Dropdown>
      </div>
    </nav>
  );
};

export default Header;
